import BaseCommand from "@/models/api/commands/BaseCommand";

export class ChangeFareBaseCommand extends BaseCommand {
  CommandName = "ChangeFareBase";
  Command: {
    Amount: number;
    IsNet: boolean;
    BookingItemTmpId: string;
  };
  constructor(sessionId: string, operationId: string, bookingItemTmpId: string, amount: number, isNet: boolean) {
    super(sessionId, operationId);
    this.Command = { BookingItemTmpId: bookingItemTmpId, Amount: amount, IsNet: isNet };
  }
}
